import { Clock } from "lucide-react";

interface ResponseTimePromiseProps {
  className?: string;
}

export function ResponseTimePromise({ className = "" }: ResponseTimePromiseProps) {
  return (
    <div
      className={`flex items-center gap-3 rounded-md border border-border bg-muted/50 p-3 ${className}`}
      data-testid="response-time-promise"
    >
      <Clock className="h-5 w-5 shrink-0 text-primary" />
      <p className="text-sm text-muted-foreground">
        <span className="font-semibold text-foreground">Our promise:</span> We return every
        call and message within one business day.
      </p>
    </div>
  );
}
